import { memo } from 'react';
import { AdvancedMarker } from '@vis.gl/react-google-maps';

import { MapWorkOrder } from '@atom/types/map';

import { getGoogleShapeCenter } from '../mapUtilities';

import {
  MARKER_STYLE,
  resolveAnchor,
  resolveOpacity,
  resolveZIndex,
} from './markerUtilities';
import WorkGroupMarkerContent from './WorkGroupMarkerContent';

type WorkGroupMarkerProps = {
  group: MapWorkOrder[];
  isActive: boolean;
  allDisabled: boolean;
  stackKey: string;
  onWorkOrderGroupClick: (stackKey: string) => void;
};

const WorkGroupMarker = ({
  group,
  isActive,
  allDisabled,
  stackKey,
  onWorkOrderGroupClick,
}: WorkGroupMarkerProps) => {
  const position = getGoogleShapeCenter(group[0].location);

  const handleClick = () => {
    if (!allDisabled) {
      onWorkOrderGroupClick(stackKey);
    }
  };

  return (
    <AdvancedMarker
      position={position}
      zIndex={resolveZIndex('asset', isActive)}
      {...resolveAnchor('workOrderGroup', isActive)}
      style={{ ...MARKER_STYLE, opacity: resolveOpacity(allDisabled) }}
      onClick={handleClick}
    >
      <WorkGroupMarkerContent count={group.length} isActive={isActive} />
    </AdvancedMarker>
  );
};

export default memo(WorkGroupMarker);
